import { UserPermission } from '@cobliteam/common-types/';

export const RoutingPermissions = {
  VIEW_ROUTES: UserPermission.VIEW_ROUTES,
  CREATE_UPDATE_DELETE_ROUTES: UserPermission.CREATE_UPDATE_DELETE_ROUTES,
  VIEW_PROOF_OF_CONCLUSION: UserPermission.VIEW_PROOF_OF_CONCLUSION,
  VIEW_ANALYTICS_AND_REPORTS: UserPermission.VIEW_ANALYTICS_AND_REPORTS,
};

export enum RoutingSpreadsheetNoPermissionMessage {
  POC = 'Sem permissão para visualizar informação. Contatar o Administrador para ativar permissão de Comprovantes',
  AnalyticsAndReport = 'Sem permissão para visualizar informação. Contatar o Administrador para ativar permissão de Relatórios e Análises',
}
